import { UserFacingError } from './errors'

export class TodoNotFoundError extends UserFacingError {
  constructor() {
    super('Todo not found')
    this.name = 'TodoNotFoundError'
  }
}

export class UnauthorizedTodoActionError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? "You don't have permission for this action")
    this.name = 'UnauthorizedTodoActionError'
  }
}

export class TodoAlreadyCompletedError extends UserFacingError {
  constructor() {
    super('Task already complete')
    this.name = 'TodoAlreadyCompletedError'
  }
}

export class TodoNotPendingError extends UserFacingError {
  constructor() {
    super('Task is not pending')
    this.name = 'TodoNotPendingError'
  }
}

export class DuplicateCategoryError extends UserFacingError {
  constructor(name: string) {
    super(`Category already exists: ${name}`)
    this.name = 'DuplicateCategoryError'
  }
}

export class InvalidAssigneeError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? "This member can't be assigned")
    this.name = 'InvalidAssigneeError'
  }
}

export class InvalidCategoryError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Invalid category')
    this.name = 'InvalidCategoryError'
  }
}

export class InvalidBlindError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Invalid blind')
    this.name = 'InvalidBlindError'
  }
}

export class InvalidPropertyError extends UserFacingError {
  constructor(message?: string) {
    super(message ?? 'Invalid property')
    this.name = 'InvalidPropertyError'
  }
}

export class NotOrgMemberError extends UserFacingError {
  constructor() {
    super('Not an active org member')
    this.name = 'NotOrgMemberError'
  }
}

export class GuestAccessDeniedError extends UserFacingError {
  constructor() {
    super('Access denied')
    this.name = 'GuestAccessDeniedError'
  }
}

export class CategoriesNotSupportedForCrewsError extends UserFacingError {
  constructor() {
    super('Categories are not available for crews')
    this.name = 'CategoriesNotSupportedForCrewsError'
  }
}
